import { useLocation } from "react-router-dom";
import ReverseProtectedRoute from "./ReverseProtectedRoute";
import SignIn from "../pages/auth/SignIn";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";

export default function AuthRoutes() {
  const location = useLocation();
  
  // Determine which component to render based on the current path
  const renderAuthComponent = () => {
    switch (location.pathname) {
      case '/signin':
        return (
          <ReverseProtectedRoute>
            <SignIn />
          </ReverseProtectedRoute>
        );
      case '/forgot-password':
        return (
          <ReverseProtectedRoute>
            <ForgotPassword />
          </ReverseProtectedRoute>
        );
      case '/reset-password':
        return (
          <ReverseProtectedRoute>
            <ResetPassword />
          </ReverseProtectedRoute>
        );
      default:
        return (
          <ReverseProtectedRoute>
            <SignIn />
          </ReverseProtectedRoute>
        );
    }
  };

  return renderAuthComponent();
}
